import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FileManager from './pages/FileManager';
import Login from './pages/Login';
import ShortcutsHelp from './components/ShortcutsHelp';
import { CssBaseline } from '@mui/material';

const App: React.FC = () => {
  return (
    <Router>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<FileManager />} />
      </Routes>
      <ShortcutsHelp open={true} onClose={() => {}} />
    </Router>
  );
};

export default App;